import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUser } from '../modules/user/selectors'
import { selectCurrentProject } from '../modules/missionControl/selectors'
import {
  setExpectedRealAllocation,
  setPointsRecords,
  setPricePerToken,
  setTaskSubmissions,
  setTotalAllocation,
  setTotalAllocationToAllParticipants,
} from '../modules/missionControl/slice'
import { fetchUserProjectPoolData } from './useMissionControlPoolStateManagement'
import { useZapDropXpData } from './useUpdateDropTaskSubmissions'

const useUpdatePoolTaskSubmissions = () => {
  const user = useSelector(selectUser)
  const project = useSelector(selectCurrentProject)
  const { fetchAndUpdateZapDropXpData } = useZapDropXpData()

  const dispatch = useDispatch()

  const updateTaskSubmissions = useCallback(async () => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!user.id || !project.id) return
        const {
          taskSubmissions,
          pointsRecords,
          totalAllocation,
          totalAllocationToAllParticipants,
          expectedRealAllocation,
          pricePerToken,
        } = await fetchUserProjectPoolData(user.id, project.id)
        if (!taskSubmissions) throw new Error('No task submissions')
        dispatch(setTaskSubmissions(taskSubmissions))
        dispatch(setPointsRecords(pointsRecords))
        dispatch(setTotalAllocation(totalAllocation))
        dispatch(
          setTotalAllocationToAllParticipants(totalAllocationToAllParticipants),
        )
        dispatch(setExpectedRealAllocation(expectedRealAllocation))
        dispatch(setPricePerToken(pricePerToken))
        fetchAndUpdateZapDropXpData()
        resolve(taskSubmissions)
      } catch (error) {
        reject(error)
      }
    })
  }, [user.id, project.id, dispatch])

  return updateTaskSubmissions
}

export default useUpdatePoolTaskSubmissions
